module.exports = __webpack_public_path__ + "static/media/billing-form.21389eb5.png";